export default __webpack_public_path__ + "static/media/bg5.b13fd88c.jpeg";